<app-tool-pricing-config [isEditMode]="false"></app-tool-pricing-config>
